<template>
  <section>
    <div class="confirm_area">
      <div class="input_confirm6">
        <ul>
          <li>
            <span>注文番号</span>
            <span>{{orderData.planEc.ecOrderNo}}</span>
          </li>
          <li>
            <span>ご注文日</span>
            <span>{{getDate(orderData.planData.planOrderDate)}}</span>
          </li>
          <li>
            <span>ご請求額</span>
            <span>{{formatPrice(orderData.planEc.ecSnapPrice)}}</span>
          </li>
          <li>
            <span>施主名</span>
            <span>{{orderData.planData.planDeliveryName}}</span>
          </li>
          <li>
            <span>納品先</span>
            <span>{{deliAddress}}</span>
          </li>
        </ul>
        <div class="action_area">
          <div class="main_btn sel_main_btn" @click="detail()">
            <a>詳細を見る</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import moment from 'moment'
// import * as FormUtil from '../../../utils/FormUtil'

export default {
  name: 'DcOrderHistory',
  components: {
  },
  props: {
    orderData: Object
  },
  data () {
    return {
    }
  },
  computed: {
    deliAddress: function () {
      let address = (this.orderData.planData.planDeliveryState ? this.orderData.planData.planDeliveryState : '') +
        (this.orderData.planData.planDeliveryCity ? this.orderData.planData.planDeliveryCity : '') +
        (this.orderData.planData.planDeliveryStreet ? this.orderData.planData.planDeliveryStreet : '')
      return address
    }
  },
  methods: {
    detail: function () {
      this.$emit('detail', this.orderData.orderNo)
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    getDate: function (date) {
      if (!moment(date).isValid()) return ''
      let time = moment(date).format('YYYY/MM/DD')
      return time
    },
    cancel: function () {
      this.$router.go(-1)
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.list_left_container {
  width: 70%;
  font-weight: bold;
}

.order_title {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/order/DcOrderHistory.vue